import React from "react";
import { useLocation } from "react-router-dom";
// import "./style.scss";
import Header from "../common/Header";
import Footer from "../common/Footer";

const MainPage = (props) => {
	const { content: Content, pageClass } = props;
	const location = useLocation();

	React.useEffect(() => {
		window.scrollTo(0, 0);
	}, [location]);
    
	let style = {
		paddingTop: props?.style?.paddingTop || '43px', 
		...props.style, 
	}

	return (
		< >
	<Header/>
			<div style={style} className="main-content clearfix mt-3">
				<Content />
			</div>
            <Footer/>
		</>
	);
};

export default MainPage;
